import { TFunction } from 'react-i18next';

import type { DropdownOption, TranslatableDropdownOption } from 'constants/_types/DropdownOptions';

const translateOptions = (t: TFunction, options: TranslatableDropdownOption[]): DropdownOption[] =>
  options.map(({ labelKey, value }) => ({ value, label: t(labelKey) }));

export default translateOptions;
